import { SessionStorage } from 'core-lib/constants/storage';
import { WEBSITE_URL } from 'core-lib/data/common';
import { trackCustomGTMEvent } from 'core-lib/utils/events';
import { EventCategoryName } from 'core-lib/types/Events';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { SkuType } from 'src/modules/parkplusStoreV2/types/product';
import { trackCtaClickedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import { Button } from 'ui-v2/components/Button';
import StepperButton from '../../StepperButton';
import { AddToCartChildProps } from '../AddToCart';

export const ProductCardAOC = (props: AddToCartChildProps) => {
  const {
    isLoading,
    isInStock,
    isInCart,
    onNotifyMe,
    onViewCart,
    onAddToCart,
    skuType,
    isSmall,
    productId,
    option = false,
    section,
  } = props;

  const { profile } = useSelector((state: any) => state.auth);
  const { basePath, asPath } = useRouter();
  const pageUrl = `${WEBSITE_URL}${basePath}${asPath}`;

  if (skuType === SkuType.FuelVoucher) {
    return (
      <Button
        label="Claim Now"
        onClick={() => {}}
        fullWidth
        variant="secondary_color"
        size="tiny"
      />
    );
  }
  if (!isInStock) {
    return (
      <Button
        label="NOTIFY ME"
        onClick={onNotifyMe}
        fullWidth
        variant="secondary_color"
        size="tiny"
      />
    );
  }
  if (isInCart) {
    return <StepperButton {...props} />;
  }
  return (
    <Button
      label="ADD"
      variant="secondary_color"
      fullWidth
      size="tiny"
      onClick={e => {
        onAddToCart(e);
        trackCtaClickedStoreV2('', 'ADD', {
          product_id: productId,
          section: section,
        });
        trackCustomGTMEvent({
          eventName: 'pm_35_add_to_cart',
          attributes: {
            category: EventCategoryName.Store,
            sku_id: productId,
            page_url: pageUrl,
          },
        });
      }}
      loading={isLoading}
    />
  );
};
